export function getConfig(value) {
  const config = (window.__preloadState || {}).config || {};
  return config[value];
}

export function getVariable(value) {
  const variables = (window.__preloadState || {}).variables || {};
  return variables[value];
}
